import React from 'react';
import numeral from 'numeral';

class IRewardUtils extends React.Component {
  static get91DayDailyReward10k(rewardPercentPerDay) {
    // console.log("in get91DayDailyReward: amount: 10000, rewardPercentPerDay: ", rewardPercentPerDay);
    return IRewardUtils.get91DayDailyReward(rewardPercentPerDay, 10000);
  }

  static get91DayWeightedApr(netApr) {
    // console.log("in get91DayWeightedApr: netApr: ", netApr);
    return IRewardUtils.getWeightedAprDisplay(netApr, 91) + " %";
  }

  static get91DayDailyReward(rewardPercentPerDay, amount) {
    // console.log("in get91DayDailyReward: amount: ", amount, ", rewardPercentPerDay: ", rewardPercentPerDay);
    return IRewardUtils.getXDayDailyReward(rewardPercentPerDay, amount, 91);
  }

  static getXDayDailyReward(rewardPercentPerDay, amount, duration) {
    if (!rewardPercentPerDay || rewardPercentPerDay === 0) {
      return 0;
    }

    let weightedRewardPercentPerDay = IRewardUtils.getWeightedRewardPercentPerDay(duration, rewardPercentPerDay);
    let weightedRewardPerDay = IRewardUtils.rewardPerDayByAmount(weightedRewardPercentPerDay, amount)
    // console.log("getXDayDailyReward: amount: ", amount, ", duration: ", duration, ", rewardPercentPerDay : ",
    //   rewardPercentPerDay, ", weightedRewardPercentPerDay: ", weightedRewardPercentPerDay,
    //   ", weightedRewardPerDay: ", weightedRewardPerDay);
    return weightedRewardPerDay;
  }

  static getWeightedAprDisplay(netApr, duration) {
    return numeral(this.getWeightedApr(netApr, duration)).format('0[.]00');
    // console.log("getDurationWeight: duration: ", duration, ", weight : ", weight);
  }

  static getWeightedApr(netApr, duration) {
    let weight = 1 + IRewardUtils.getDurationWeight(duration);
    let weightedNetApr = (netApr * weight);

    // console.log("getWeightedApr: netApr: ", netApr, ", duration: ", duration,
    //   "weight: ", weight, ", weightedNetApr : ", weightedNetApr);
    return weightedNetApr;
  }

  static getWeightedRewardPercentPerDay(duration, rewardPercentPerDay) {
    let weight = IRewardUtils.getDurationWeight(duration);
    let overallWeight = 1 + weight;
    let weightedRewardPercentPerDay = overallWeight * rewardPercentPerDay;
    // console.log("getWeightedRewardPercentPerDay: duration: ", duration, ", weight : ", weight,
    //   ", overallWeight: ", overallWeight, "rewardPercentPerDay: ", rewardPercentPerDay,
    //   ", weightedRewardPercentPerDay: ", weightedRewardPercentPerDay);

    return weightedRewardPercentPerDay;
  }

  static getDurationWeight(duration) {
    let weight = Math.log(duration) / Math.log(1.2)
    // console.log("getDurationWeight: duration: ", duration, ", weight : ", weight);
    return weight/100;
  }

  static rewardPerDay(cell, row) {
    return IRewardUtils.rewardPerDayByAmount(cell, 10000);
  }

  static rewardPerDayByAmount(rewardPercent, amount) {
    if (!rewardPercent && rewardPercent !== 0) return "";
    return numeral(rewardPercent * amount/100).format('0[.]00');
  }
}

export default IRewardUtils;



// WEBPACK FOOTER //
// ./src/iotex/IRewardUtils.js